module.exports = __webpack_public_path__ + "img/cyhz.6679afb4.png";